<script setup lang="ts">
import { isNotEmpty } from '@/utils/util'
import { computed, ref, type Ref } from 'vue'
import defaultAvatar from '@/assets/default_avatar.jpg'

const props = defineProps({
  src: {
    type: String,
    required: true
  },
  ratio: {
    type: Number,
    default: 1
  },
  size: {
    type: String,
    default: 'large',
    validator: (value: string) => ['small', 'normal', 'medium', 'large', 'xMedium'].includes(value)
  },
  circle: {
    type: Boolean,
    default: false
  },
  alt: {
    type: String,
    default: ''
  }
})

const imgRef: Ref<HTMLImageElement | undefined> = ref()

const calcSize = computed(() => {
  let unit = 4
  switch (props.size) {
    case 'small':
      unit = 3
      break
    case 'normal':
      unit = 5.5
      break
    case 'medium':
      unit = 7
      break
    case 'large':
      unit = 10
      break
    case 'xMedium':
      unit = 8.5
      break
    default:
      unit = 6
      break
  }
  const w = props.ratio == 1 ? unit * 0.9 : props.ratio > 1 ? unit : unit * props.ratio
  const h = props.ratio == 1 ? unit * 0.9 : props.ratio > 1 ? unit / props.ratio : unit
  let border = [w + 'rem', h + 'rem']
  console.log('props.circle ', props.circle)
  if (props.circle) {
    return [unit * 0.9 + 'rem', unit * 0.9 + 'rem']
  }
  return border
})

const imgSrc = computed(() => {
  if (typeof window !== 'undefined' && props.src) {
    return props.src
  }
  return props.src || defaultAvatar
})

const loaded = ref(false)
const error = ref(false)
</script>
<template>
  <!-- :class="props.size == 'small' ? 'max-w-8 max-h-8' : (props.size == 'medium' ? 'max-w-24 max-h-24' : 'max-w-40 max-h-40') -->
  <div
    :style="{ width: calcSize[0], height: calcSize[1] }"
    relative
    flex-r-center
    bg-active
    cursor-pointer
    :class="props.circle ? 'rounded-full' : 'rounded-2'"
    overflow-hidden>
    <div
      v-if="!loaded && !error"
      absolute
      bottom-0
      left-0
      right-0
      top-0
      flex-r-center
      bg-active
      :class="props.size == 'small' ? (props.circle ? 'rounded-full' : 'rounded') : 'rounded-2'">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
        <g fill="none" stroke="#b3b3b3" stroke-linecap="round" stroke-width="1.3">
          <path
            stroke-dasharray="60"
            stroke-dashoffset="60"
            stroke-opacity="0.3"
            d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z">
            <animate fill="freeze" attributeName="stroke-dashoffset" dur="1.95s" values="60;0" />
          </path>
          <path stroke-dasharray="15" stroke-dashoffset="15" d="M12 3C16.9706 3 21 7.02944 21 12">
            <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.45s" values="15;0" />
            <animateTransform
              attributeName="transform"
              dur="2.25s"
              repeatCount="indefinite"
              type="rotate"
              values="0 12 12;360 12 12" />
          </path>
        </g>
      </svg>
    </div>
    <img
      v-if="isNotEmpty(imgSrc)"
      ref="imgRef"
      h-full
      w-full
      :src="imgSrc"
      :alt="props.alt"
      :class="props.size == 'small' ? (props.circle ? 'rounded-full' : 'rounded') : 'rounded-2'"
      @load="loaded = true"
      @error="error = true"
      :style="{ 'object-fit': props.circle ? 'cover' : 'contain', width: calcSize[0], height: calcSize[1] }" />
  </div>
</template>
<style lang="scss" scoped></style>
